<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 4977 4977"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="2489" cy="2489" r="2489"/>
     <path class="fil1"
           d="M2365 1797l-771 197 -20 -43c-8,-20 -9,-27 -18,-48 -98,-219 -338,-331 -584,-271 -232,57 -461,294 -431,599 27,269 265,478 570,436 260,-35 438,-242 481,-483l16 -51c42,-28 671,-128 772,-140 -3,297 36,306 -95,487 -52,72 -36,110 -35,248l0 1296 473 1c14,-92 2,-1206 4,-1408 2,-188 -130,-175 -130,-343l0 -281c95,10 762,104 779,155 20,60 4,77 51,183 28,63 67,109 99,155 190,265 844,284 908,-244 75,-611 -810,-889 -1028,-300l-22 50 -784 -196 -3 -840 -38 -4c-204,14 -413,48 -488,320 -51,182 24,345 152,450 46,38 85,45 142,75z"/>
   </g>
  </svg>

</template>

<script>
export default {
  name: 'WeatherStation',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
